export default __webpack_public_path__ + "static/media/inkomoko.cf922968.png";